import { HarborClientModule } from "@pharaday/api";
import { EnvVariablesModule } from "@pharaday/env";
import { Container } from "inversify";
import "reflect-metadata";

import { OnboardingModule } from "./infrastructure/onboarding.module";

export const UnauthenticatedContainer = new Container({ defaultScope: "Singleton" });

UnauthenticatedContainer.load(EnvVariablesModule, HarborClientModule, OnboardingModule);
